<div *ngIf="saving" class="loading-container" [class.fill-parent]="fillParent">
  <img class="loading" src="assets/layout/images/Spinner_Mark_Dark.svg" alt="loading spinner" />
</div>
